<template>
<!-- 函数组件替换 -->
    <div class='kimg'>
      <img class="img" :src="src" alt="" @click="Onclick">
    </div>
</template>

<script>
export default {
    props: {
      src: String
    },
    methods:{
      Onclick(){
        this.$emit("Onclick");
      }
    }    
};
</script>

<style scoped lang="less">
.kimg{
  background: #fff;
  overflow: hidden;
  .img{
    width: 100%;
    height: 100%;
    object-fit: contain; 
  }
}
</style>
